// LLM:METADATA
// :topology: [Domain:StateManagement | Role:UIState | Pattern:Module]
// :relates-to: required-by: "All Components"
// :rationale: "Global UI state management"
// :contract: pre: "UI action dispatched", post: "UI state updated", invariant: "UI state is always persisted"
// :decision_cache: "Chose Vuex module for centralized UI state [UI-001]"
// LLM:END

import { setTopologyId } from "@/services/logger"
import { TOPOLOGY_STORE_UI } from "@/constants/topology"

// Set topology ID for semantic logging
setTopologyId(TOPOLOGY_STORE_UI)

export default {
  namespaced: false,
  state: {
    pagesTransition: false,
    notifications: [],
  },
  getters: {
    getPagesTransition: (state) => () => state.pagesTransition,
    getNotifications: (state) => () => state.notifications,
  },
  mutations: {
    SET_TRANSITION(state, val) {
      state.pagesTransition = val
    },
    SET_NOTIFICATIONS(state, data) {
      state.notifications = data
    },
  },
  actions: {
    setPagesTransition({ commit }, newValue) {
      commit("SET_TRANSITION", newValue)
    },
    setNotifications({ commit }, newValue) {
      commit("SET_NOTIFICATIONS", newValue)
    },
  },
}
